import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase/firebase-config';
import { signOut } from 'firebase/auth';
import { collection, getDocs } from 'firebase/firestore';
import { 
  LayoutDashboard, Image as ImageIcon, Package, 
  Megaphone, Settings, LogOut, Menu, X, PlayCircle,
  BookOpen, Layers, FlaskConical, Phone, Loader2
} from 'lucide-react';

// Bileşen importları
import SliderManager from '../SliderManager/SliderManager';
import VideoManager from '../VideoManager/VideoManager';
import AnnouncementManager from '../AnnouncementManager/AnnouncementManager';
import AboutManager from '../AboutManager/AboutManager';
import CategoryManager from '../CategoryManager/CategoryManager';
import ProductManager from '../ProductManager/ProductManager';
import AdditivesManager from '../AdditivesManager/AdditivesManager';
import ContactManager from '../ContactManager/ContactManager';
import './DashBoard.css';

const DashBoard = () => {
  const [activeMenu, setActiveMenu] = useState('Genel Bakış');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleLogout = async () => {
    try { 
      await signOut(auth); 
    } catch (error) { 
      console.error("Çıkış başarısız:", error); 
    }
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Sağ taraftaki içerik alanını render eden fonksiyon
  const renderContent = () => {
    switch (activeMenu) {
      case 'Genel Bakış': return <StatsOverview />;
      case 'Slider (Hero)': return <SliderManager />;
      case 'Kurumsal Ayarlar': return <AboutManager />;
      case 'Ürün Grupları': return <CategoryManager />;
      case 'Yem Katkıları': return <AdditivesManager />;
      case 'Videolar': return <VideoManager />;
      case 'Duyurular': return <AnnouncementManager />;
      case 'Ürün Yönetimi': return <ProductManager/>;
      case 'İletişim Ayarları': return <ContactManager />;
      default: return <StatsOverview />;
    }
  };

  return (
    <div className="admin-wrapper">
      {/* MOBİL İÇİN KARARTMA */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      {/* SIDEBAR */}
      <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo-box">BY</div>
          <div className="header-text">
            <h3>Bigma Yem</h3>
            <span>Kontrol Paneli</span>
          </div>
          <button className="mobile-close-btn" onClick={toggleSidebar}><X size={24} /></button>
        </div>

        <nav className="sidebar-nav">
          {[
            { id: 'Genel Bakış', icon: <LayoutDashboard size={20} /> },
            { id: 'Slider (Hero)', icon: <ImageIcon size={20} /> },
            { id: 'Kurumsal Ayarlar', icon: <BookOpen size={20} /> },
            { id: 'Ürün Grupları', icon: <Layers size={20} /> },
            { id: 'Yem Katkıları', icon: <FlaskConical size={20} /> },
            { id: 'Videolar', icon: <PlayCircle size={20} /> },
            { id: 'Duyurular', icon: <Megaphone size={20} /> },
            { id: 'Ürün Yönetimi', icon: <Package size={20} /> },
            { id: 'İletişim Ayarları', icon: <Phone size={20} /> },
            { id: 'Site Ayarları', icon: <Settings size={20} /> }
          ].map((item) => (
            <div 
              key={item.id}
              className={`nav-item ${activeMenu === item.id ? 'active' : ''}`} 
              onClick={() => {setActiveMenu(item.id); setIsSidebarOpen(false);}}
            >
              {item.icon} <span>{item.id}</span>
            </div>
          ))}
        </nav>

        <button className="logout-btn" onClick={handleLogout}>
          <LogOut size={18} /> <span>Güvenli Çıkış</span>
        </button>
      </aside>

      {/* ANA İÇERİK ALANI */}
      <main className="main-content">
        <header className="content-header">
          <div className="header-left">
            <button className="hamburger-btn" onClick={toggleSidebar}><Menu size={28} /></button>
            <h2>{activeMenu}</h2>
          </div>
          <div className="admin-profile">
            <span>Yönetici</span>
            <div className="avatar">BY</div>
          </div>
        </header>

        <div className="dashboard-body">
          {renderContent()}
        </div>
      </main>
    </div>
  );
};

/* İSTATİSTİK BİLEŞENİ - FİREBASE BAĞLANTILI */
const StatsOverview = () => {
  const [counts, setCounts] = useState({ products: 0, sliders: 0, news: 0, messages: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [prodSnap, sliderSnap, newsSnap, msgSnap] = await Promise.all([
          getDocs(collection(db, "products")),
          getDocs(collection(db, "sliders")),
          getDocs(collection(db, "announcements")),
          getDocs(collection(db, "messages"))
        ]);

        setCounts({
          products: prodSnap.size,
          sliders: sliderSnap.size,
          news: newsSnap.size,
          messages: msgSnap.size
        });
      } catch (err) {
        console.error("Veriler sayılamadı:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCounts();
  }, []);

  if (loading) return (
    <div className="loading-stats">
      <Loader2 className="animate-spin" /> İstatistikler yükleniyor...
    </div>
  );

  return (
    <div className="stats-grid">
      <div className="stat-card gold">
        <div className="stat-content">
          <h3>{counts.products}</h3>
          <span>Toplam Ürün</span>
        </div>
        <Package className="stat-icon" size={40} opacity={0.2} />
      </div>

      <div className="stat-card green">
        <div className="stat-content">
          <h3>{counts.sliders}</h3>
          <span>Aktif Slider</span>
        </div>
        <ImageIcon className="stat-icon" size={40} opacity={0.2} />
      </div>

      <div className="stat-card blue">
        <div className="stat-content">
          <h3>{counts.messages}</h3>
          <span>Gelen Mesajlar</span>
        </div>
        <Phone className="stat-icon" size={40} opacity={0.2} />
      </div>

      <div className="stat-card dark">
        <div className="stat-content">
          <h3 style={{ color: '#10b981', fontSize: '1.2rem' }}>AKTİF</h3>
          <span>Sistem Durumu</span>
        </div>
        <LayoutDashboard className="stat-icon" size={40} opacity={0.2} />
      </div>
    </div>
  );
};

export default DashBoard;